export const NO_STEP_ID = 'no-step';